<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        minWidth: '100%',
        minHeight: '45%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
    }">
        <div class="popupContainer">
            <van-row class="title">
                <van-col span="22" style="display: flex; justify-content: center; align-items: center;">
                    {{ $t('activity.smsVerificatin') }}
                </van-col>
                <van-col span="2">
                    <img src="@/assets/profile/cs_close.png" alt="" @click="close">
                </van-col>
            </van-row>
            <van-row v-if="!isShowOTP" justify="center" class="fieldContainer">
                <van-col span="22" style="margin-bottom: 15px;" class="input_container">
                    <van-field class="numberInput" label-width="35px" v-model="phoneNumber" label="+55"
                        left-icon="phone-o" type="number" :placeholder="$t('loginRegister.phoneFormat')" />
                </van-col>
                <van-col span="16" style="padding-top: 15px;">
                    <MainButton :title="$t('activity.verify')" :activeStatus="isPhoneVerifyActive"
                        @click="verifyPhone" />
                </van-col>
            </van-row>

            <van-row v-if="isShowOTP" justify="center" class="fieldContainer">
                <van-col v-if="isShowOTP" span="24" class="inputCont">
                    <p style=" color: #999; text-align: center;">{{ $t('activity.enterOTPcode') }}</p>
                    <div class="otp-input-container">
                        <input v-for="(digit, index) in otpFields" :key="index" v-model="otpFields[index]" maxlength="1"
                            class="otp-input"  type="text" inputmode="numeric" pattern="[0-9]*" @input="handleInput(index, $event)"
                            @keydown.backspace="handleBackspace(index, $event)" ref="otpInput" />
                    </div>
                </van-col>
                <van-col span="16" style="padding-top: 15px;">
                    <MainButton :title="$t('activity.verify')" :activeStatus="isOTPVerifyActive" @click="submitOtp" />
                </van-col>
            </van-row>
        </div>

    </van-popup>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, PropType, computed, defineProps } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { getOtpVerification, getPhoneVerification } from '@/api/activity';
import MainButton from '../../components/common/mainButton.vue';

const props = defineProps({
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
})
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const title = ref('')
const loadingRef = ref()
const isShowOTP = ref(false)
const phoneNumber = ref('')
const otpFields = ref<any[]>(['', '', '', '', '', ''])
const otpCode = ref('')
const otpInput = ref()
const open = (data: any) => {
    show.value = true
    title.value = `R$ ${data} `
}

const close = () => {
    show.value = false
    phoneNumber.value = ''
    otpCode.value = ''
    otpFields.value = ['', '', '', '', '', '']
    isShowOTP.value = false

    if (otpInput.value && Array.isArray(otpInput.value)) {
    otpInput.value.forEach((input: any) => {
      if (input) input.value = ''
    })
  }
}
const emits = defineEmits(['updateInfo'])
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const verifyPhone = () => {
    loadingRef.value.open()
    let data = {
        phoneNo: phoneNumber.value,
        area_code: "55"
    }
    getPhoneVerification(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        isShowOTP.value = true
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const handleInput = (index: any, event: any) => {
    otpFields.value[index] = event.target.value

    if (event.target.value.length === 1 && index < otpFields.value.length - 1) {
        otpInput.value[index + 1].focus();
    }

    otpCode.value = otpFields.value.join('');
}
const handleBackspace = (index: any, event: any) => {
    if (event.target.value === '' && index > 0) {
        otpInput.value[index - 1].focus();
    }
}
const isPhoneVerifyActive = computed(() => {
    return (
        phoneNumber.value.length == 11
    );
});
const isOTPVerifyActive = computed(() => {
    return (
        otpCode.value.length == 6
    );
});
const submitOtp = () => {
    loadingRef.value.open()
    let data = {
        phoneNo: phoneNumber.value,
        area_code: 55,
        code: otpCode.value
    }
    getOtpVerification(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        setTimeout(() => {
            show.value = false
            emits('updateInfo')
        }, 500)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
    border: 1px solid rgba(255, 255, 255, 0.10) !important;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, .25) !important;
    backdrop-filter: blur(20px) !important;
    width: 100%;
    height: 45vh;
    overflow: hidden;
}

.title {
    padding: 10px 25px;
    font-size: 14px;
    color: #ffffffa6;
    font-size: 20px;
    display: flex;
    justify-content: center;
}

.title img {
    width: 20px;
    padding-top: 10px;
}

.van-overlay {
    background-color: #00000047
}

.fieldContainer {
    padding: 30px 25px 10px;
}

.btn_container {
    padding: 10px 20% 30px;
}

.input_container>>>.van-field {
    border-radius: 30px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.04);
    color: #ffffffd9;
    padding: 12px 20px !important;
}

.input_container>>>.van-field__control {
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 13px;
}

.input_container>>>.van-field__control::placeholder {
    color: #ffffff40 !important;
    font-family: monospace;
}

.input_container>>>.van-field__right-icon {
    color: #ffffff40 !important;
}

.input_container>>>.van-field__label {
    color: #fff;
}


.otp-input {
    width: 40px;
    height: 40px;
    text-align: center;
    font-size: 18px;
    border-radius: 5px;
    border: 1px solid #134000;
    color: #000000;
}

.otp-input-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    color: #000000;
    padding: 5px;
}
</style>